/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const PrayIconConfig = {
  name: 'PrayIcon',
  height: 512,
  width: 384,
  svgPath: 'M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(PrayIconConfig);
//# sourceMappingURL=pray-icon.js.map